export default __webpack_public_path__ + "static/gmail-addon-store-email-resized-b1ebc37afa3a5653211e42f30727ee42.mp4";